import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
export default function SimausRoute({ children }) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => { let active = true;
    authFetch("/firma").then(data => { if (active) setState({ allowed: data?.items?.[0]?.app_variant === "SIMAUS" }); })
      .catch(error => { if (active) setState({ error: error.message }); });
    return () => { active = false; };
  }, []);
  if (state.loading) return <div role="status"><Spinner size="sm" /> Se încarcă firma…</div>;
  if (!state.allowed) return <Alert variant="danger">{state.error || "Modul disponibil doar pentru Producție SIMAUS."}</Alert>;
  return children;
}
